<!-- 
Overrides for a levy collection.
-->
<template>
  <div>
    <our-heading 
      :breadcrumbs="getBreadcrumbs('overrides')"
      :subtitle="statusDescription"
      title="Overrides"
      subtitle-tooltip="Levy collection status"
      user-guide-topic="levy-collection-overrides"
    >
      <template v-slot:navigator>
        <levy-collection-navigator :levy-collection-id="levyCollectionId" :sandbox="isSandbox" />
      </template>
    </our-heading>
    <v-btn v-if="canCopyOverrides" :block="xs" class="ml-0 mb-3" @click="showOverrideCopyDialog = true">
      <v-icon class="mr-2">file_copy</v-icon>
      Copy overrides from last year
    </v-btn>
    <overrides-listing v-if="hasProviders" ref="listing" :levy-collection-id="levyCollectionId" />
    <our-getting-started-hint v-if="!hasProviders && loaded" :levy-collection-id="levyCollectionId">
      Overrides cannot be created without in-scope providers. 
      Go to <i>Workflow</i> and run the <i>Import in-scope providers</i> task to get started.
    </our-getting-started-hint>
    <override-copy-dialog v-model="showOverrideCopyDialog" :levy-collection-id="levyCollectionId" />
  </div>
</template>

<script>
import LevyCollectionNavigator from "@/components/levy-collections/LevyCollectionNavigator.vue";
import OverrideCopyDialog from "@/components/levy-collection-overrides/OverrideCopyDialog.vue";
import levyCollectionMixins from "./mixins";
import OverridesListing from "@/components/levy-collection-overrides/OverridesListing.vue";
import overrideMixins from "@/mixins/override.mixins";
import lookupMixins from "@/mixins/lookup.mixins";

export default {
  components: {
    LevyCollectionNavigator,
    OverridesListing,
    OverrideCopyDialog
  },
  mixins: [levyCollectionMixins, overrideMixins, lookupMixins],
  data() {
    return {
      showOverrideCopyDialog: false
    };
  },
  computed: {
    state() {
      return this.$store.state.levyCollections.view;
    },
    hasProviders() {
      return this.state.data.inScopeProviders > 0;
    },
    loaded() {
      return this.state.loaded;
    },
    canCopyOverrides() {
      return (
        this.canEditOverrides(null) &&
        !this.doesLookupHaveAttribute(this.state.data.type, "IsSandbox", this.lookups.levyCollectionTypes)
      );
    },
    xs() {
      return this.$vuetify.breakpoint.xsOnly;
    }
  }
};
</script>
